<template>
    <modal @close="close" dialog="modal-lg" class="reservation-modal payment dark-top">
        <div slot="title">
            <view-header title="Payment"></view-header>
        </div>

        <div slot="body" class="d-flex">
            <div class="p-4 col-5 sidebar">
                <div class="summary pb-5">
                    <summary-header :tag="false"></summary-header>

                    <div>
                        {{ paxTotal }} PAX, {{ extrasQuantityTotal }} extras
                    </div>
                </div>

                <!-- <promo :reservation="getClonedReservation" :product="product"></promo> -->

                <discount
                    :reservation="getClonedReservation"
                    :product="product"
                    @updateDiscountType="updateDiscountType"
                    @updateDiscountValue="updateDiscountValue">
                </discount>

                <summary-totals :reservation="getClonedReservation" :product="product"></summary-totals>
            </div>

            <div class="col-7 p-4 main">
                <h5 class="bold mb-2">Select payment details</h5>
                <div class="fs-small">Set amount and payment method, you can also split the bill</div>

                <payment-methods
                    :reservation="getClonedReservation"
                    :product="product"
                    @validatePayments="validatePayments"
                    @updatePayments="updatePayments">
                </payment-methods>

                <label>Description</label>
                <textarea class="full" placeholder="" v-model="form.billing.description"></textarea>

                <payment-details
                    :reservation="getClonedReservation"
                    :product="product"
                    @updateDetails="updateDetails">
                </payment-details>
            </div>
        </div>

        <div slot="footer">
            <button type="button" class="btn cancel wide" @click="cancel">Cancel</button>
            <button type="button" class="btn ok wide" :disabled="disabled" @click="submit">Submit</button>
        </div>
    </modal>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { reservationsMixin } from '@/mixins/reservations'
    import Modal from './Modal'
    import SummaryHeader from '@/components/reservations/summary/SummaryHeader'
    import SummaryTotals from '@/components/reservations/summary/SummaryTotals'
    import Promo from '@/components/reservations/Promo'
    import Discount from '@/components/reservations/Discount'
    import PaymentMethods from '@/components/reservations/payment/PaymentMethods'
    import PaymentDetails from '@/components/reservations/payment/PaymentDetails'
    import ViewHeader from '@/components/reservations/view/ViewHeader'
    import extendedVSelect from '@/extends/vue-select'

    export default {
        mixins: [reservationsMixin],
        data: function () {
            return {
                form: {},
                disabled: true,
            }
        },
        created: function() {
            if (this.getClonedReservation) {
                this.form = JSON.parse(JSON.stringify(this.getClonedReservation));
            }
        },
        computed: {
            ...mapGetters([
                'getClonedReservation',
                'account',
            ]),
            reservation: function() {
                return this.getClonedReservation;
            },
            product: function() {
                return this.getClonedReservation.event.product;
            }
        },
        methods: {
            ...mapActions([
                'updateClonedReservation',
                'addReservation',
                'resetClonedReservation',
                'clearActiveReservation',
                'closeModal',
            ]),
            cancel: function() {
                this.close();
            },
            close: function() {
                this.closeModal();
            },
            submit: function() {
                this.form.billing.description = this.description;

                console.log('Saving form', JSON.stringify(this.form));

                this.addReservation({
                    action: 'create',
                    fields: { supplierId: this.account.supplierId, reservation: this.form }
                }).then(() => {
                    let date = moment(this.form.event.start).format('YYYY-MM-DD')
                    this.$store.dispatch('removeDayFromCache', date);
                });
            },
            validatePayments: function(invalid) {
                this.disabled = invalid;
            },
            updatePayments: function(payments) {
                if (payments) {
                    let cleanPayments = [];

                    // Remove empty payments (value 0.00)

                    payments.forEach(p => {
                        if (parseInt(p.value) > 0) {
                            cleanPayments.push(p);
                        }
                    });

                    this.form.billing.payments = cleanPayments;

                    console.log('updateFields on ReservationPayment: updated payments to ', this.form);
                }
            },
            updateDetails: function(details) {
                this.form.billing.details = details;
            },
            updateDiscountType: function(discountType) {
                this.form.billing.discountType = discountType;
                console.log('Updated discountType with', discountType);
            },
            updateDiscountValue: function(discountValue) {
                this.form.billing.discountValue = parseFloat(discountValue);
                console.log('Updated discountValue with', discountValue);
            },
        },
        components: {
            Modal,
            vSelect: extendedVSelect,
            SummaryHeader,
            SummaryTotals,
            Promo,
            Discount,
            PaymentMethods,
            PaymentDetails,
            ViewHeader,
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';

    .promo, .discount, .pricing-details, .summary {
        padding: 0.5rem 1rem;
        background: $lightest;
        border: 1px solid #e6eaee;
        border-width: 1px 1px 0;
        font-size: 0.8rem;
    }

    .pricing-details {
        background: $faded;
    }

    .payment {
        .discount {
            input[type=text] {
                max-width: 112px;
                margin-bottom: 0;
            }
        }

        .promo {
            input[type=text] {
                max-width: 98px;
                margin-bottom: 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// ReservationPayment.vue?321d2bbf